export const GIT_COMMIT = '014c361bfb15ce3fe4366f8a1c5dc06d76078e18'
